import { forwardRef } from 'react';

import type { IconProps } from './types';

export const ChevronLeft = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', ...props }, forwardedRef) => (
    <svg
      width="8"
      height="8"
      viewBox="0 0 1024 1024"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={forwardedRef}
    >
      <path
        d="M782.811 83.64c-1.903-24.841-13.589-46.63-31.167-61.766l-.119-.099C735.822 8.242 715.227 0 692.706 0c-27.432 0-52.01 12.228-68.577 31.534l-.102.121-361.319 421.538c-13.527 15.7-21.764 36.293-21.764 58.807s8.237 43.107 21.863 58.926l-.099-.119 361.319 421.538c16.669 19.424 41.244 31.655 68.679 31.655 22.52 0 43.115-8.243 58.937-21.874l-.119.099c19.345-16.663 31.519-41.19 31.519-68.563 0-22.574-8.282-43.214-21.97-59.05l.096.116-310.743-362.73 310.743-362.73c13.603-15.723 21.888-36.369 21.888-58.951a92.2 92.2 0 0 0-.265-6.984l.02.305z"
        fill={color}
      />
    </svg>
  )
);

export default ChevronLeft;
